import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {
  Accordion,
  AccordionActions,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Avatar,
  Badge,
  Button,
  CircularProgress,
  Icon,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import './home.sass'
import './event.sass'
import { utils, read, writeFile } from 'xlsx';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';

import CheckIcon from '@mui/icons-material/Check';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { useForm, SubmitHandler } from 'react-hook-form';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';

import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';

import SearchIcon from '@mui/icons-material/Search';


import visitorLogo from '../assets/images/client_not_set.png'

import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { ResponsiveLine } from '@nivo/line'


import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';

import TextField from '@mui/material/TextField';
import FormControl, { useFormControl } from '@mui/material/FormControl';
import UserCard from '../Components/UserCard/UserCard';

import { apiEvent, apiJaiminho, apiUser, refreshToken } from '../Components/ApiCall';
import UserCardLoader from '../Components/UserCard/UserCardLoader';
import { linearGradientDef } from '@nivo/core';
import { DateCalendar, DayCalendarSkeleton, DesktopDatePicker, PickersDay, PickersDayProps } from '@mui/x-date-pickers';

import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import SyncSummaryHeader from '../Components/SyncSummaryHeader';
import UserEventCart from '../Components/UserCard/UserEventCard';
import dayjs, { Dayjs } from 'dayjs';
import './gamesync.sass';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

type FormData = {
  id: number;
  document: string;
};

// function createData(
//   tickets: number,
//   cancelled: number,
//   synked: number,
//   unique: number,
//   duplicity: number,
//   last_ticket: string,
//   last_sync: string,
//   sync_waiting: number,
//   sync_error: number,
// ) {
//   return {
//     tickets,
//     cancelled,
//     synked,
//     unique,
//     duplicity,
//     last_ticket,
//     last_sync,
//     sync_waiting,
//     sync_error,
//    };
// }

const dateFormatter = (dateTime:string, fix = false, plus = false)=>{

  const options:any = {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  const oldDate = new Date(dateTime);

  if(fix){
    oldDate.setHours(oldDate.getHours() - 3);
  }


  if(plus){
    oldDate.setHours(oldDate.getHours() + 3);
  }

  if (isNaN(oldDate.getTime())) {
    return '--';
  }

  return oldDate.toLocaleDateString('pt-BR', options).split(',').join( )
}

const GameSync = () => {
  const { t } = useTranslation();
  // return <h1>{t('hello_world')}</h1>;


  const [value, onChange] = useState<Value>([new Date(), new Date()]);

  const [displayUserProfile, setDisplayUserProfile] = useState(false)
  const [userProfile, setUserProfile] = useState({})




  const { register, handleSubmit, formState: { errors }, setValue } = useForm<FormData>();

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const timer = React.useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const [notFound, setNotFound] = React.useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  const activateGame  = async (eventData:any) => {


    try {
      const response = await apiEvent.post(`/event/active/list`,
        {
          name: `${eventData.home} vs ${eventData.visitor}`,
          companyName: companydata.name,
          eventsIdlist: eventData.eventsIdlist
        }
      );

      alert('Partida Iniciada!')
      window.location.reload()
    }catch(e){
      console.log(e)
    }
  }


  const [duplicatedTickets, setDuplicatedTickets] = useState<any>(null);
  const getDuplicatedTickets  = async (eventId:any) => {


    try {
      const response = await apiEvent.get(`/tickets/vlegacy/duplicated/${eventId}`);

      setDuplicatedTickets(response.data)
    }catch(e){
      console.log(e)
    }
  }


  const [syncStatusSummary, setSyncStatusSummary] = React.useState(null);
  const fetchSyncStatusSummary = async () => {

    try {
      const response = await apiEvent.get(`/tickets/v3/summary/all`);

      setSyncStatusSummary(response.data)

    } catch (error) {
      console.error(error);
    }

  }

  // const fetchSyncSummary = async () => {

  //   try {
  //     const response = await apiEvent.get(`/tickets/v3/summary/all`);

  //     setRows([createData(
  //       (response.data?.total_tickets[0]?.count || 0),
  //       (response.data?.total_tickets[1]?.count || 0),
  //       0,
  //       0,
  //       1554,
  //       (dateFormatter(response.data?.last_ticket?.createdAt) || '- -'),
  //       (dateFormatter(response.data?.last_ticket?.createdAt) || '- -'),
  //       0, 0)])

  //   } catch (error) {
  //     console.error(error);
  //   }

  // }

  const [rows, setRows] = useState<any>([])

  const closeUserSearchBox = () => {
    setUserProfile({})
    setDisplayUserProfile(false)
    setNotFound(false)
  }

  const handleChange = () => {
    console.log('oie')
  }

  const [companydata, setCompanydata] = React.useState({
    name: 'Bepass',
    logo: 'https://storage.googleapis.com/companies-assets/bepass/bepass_logo_default.png'
  });

  const [bannerData, setBannerData] = React.useState({
    eventType: 'game',
    home: 'TBD',
    visitor: 'TBD',
    visitorLogo: visitorLogo,
    eventDate: 'TBD',
    status: 'idle',
    eventsIdlist: [],
    externalId: ''
  });

  const [eventList, setEventList] = useState<any>([])

  const [auditDeviceList, setAuditDeviceList] = useState<any>([])

  const [reportTicketList, setReportTicketList] = useState<any>([])

  const [ticketsSyncAuditSummary, setTicketsSyncAuditSummary] = useState<any>(null)

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const fetchData = async () => {
    try {

      const companyId = sessionStorage.getItem('company_id') ||  'na'
      const response = await apiEvent.get(`/event/group/events/company/${companyId}`);

      const activeEvents = response.data.events.filter((item:any) => item.isActive)
      getEventBannerInfo(activeEvents[0])
      setEventList(activeEvents)
      fetchEventSummary('all')
      fetchAuditSummary()
      fetchTicketsData()
      // fetchSyncSummary()
      fetchSyncStatusSummary()
      getDuplicatedTickets('79670')
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTicketSyncAuditSummary = async () => {
    const _no_show = sessionStorage.getItem('pluft')
    if(_no_show){
      return false
    }
    try {

      const response = await apiEvent.get(`/sync/summary/sync`);

      setTicketsSyncAuditSummary(response.data)
    } catch (error) {
      setTicketsSyncAuditSummary(null)
      console.error(error);
    }
  };

  const changeEventSummary = async (eventId:any) => {
    console.log(eventId)
    console.log(eventList)

    const activeEvents = eventList.filter((item:any) => item.id === eventId)

    getEventBannerInfo(activeEvents[0])
    fetchEventSummary('all')
    fetchAuditSummary()
    fetchTicketsData()
    // fetchSyncSummary()
  }

  const getEventBannerInfo = (item:any) => {
    if(!item){
      return false
    }

    const externalId = item.events[0]?.externalId || '';

    setBannerData({
      eventType: 'game',
      home: item.events[0].eventName.split(' x ')[0] || '',
      visitor: item.events[0].eventName.split(' x ')[1] || 'TBD',
      visitorLogo: visitorLogo,
      eventDate: item.events[0].startDateTime,
      status: item.events[0].status,
      eventsIdlist: item.events.map((item:any) => item.id),
      externalId
    })
  }


const [summaryList, setSummaryList] = useState<any>([])

const [summaryData, setSummaryData] = useState({
  ticket_faces: 0,
  tickets_without_faces: 0,
  tickets_canceled: 0,
  total_valid_tickets: 0
})

const fetchEventSummary = async (eventId: any) => {
  try {
    const response = await apiEvent.get(`/tickets/vlegacy/summary/${eventId}`);

    let data: any[] = []

    if (Array.isArray(response.data)) {
      data = response.data;
    } else if (response.data.total_tickets) {
      data = response.data.total_tickets.map((item: any) => ({
        ...item,
        has_face_associated: response.data.last_ticket?.hasFaceAssociated ?? false
      }));
    }

    let tempResult = {
      ticket_faces: 0,
      tickets_without_faces: 0,
      tickets_canceled: 0,
      total_valid_tickets: 0
    };

    const activeData = data.find(item => item.status === 'active');
    const canceledData = data.find(item => item.status === 'canceled');

    setTotalGameTickets(Number(activeData?.count || 0));
    setCanceledGameTickets(Number(canceledData?.count || 0));

    data.forEach((item: any) => {
      const hasFace = item.has_face_associated ?? false;
      const count = Number(item.count);

      if (item.status === 'active') {
        if (hasFace) {
          tempResult.ticket_faces += count;
        } else {
          tempResult.tickets_without_faces += count;
        }
        tempResult.total_valid_tickets += count;
      } else {
        tempResult.tickets_canceled += count;
      }
    });

    // setSummaryData(tempResult)
    // setSummaryList([{ tickets: tempResult.total_valid_tickets, without_faces: tempResult.tickets_without_faces, cancelled: tempResult.tickets_canceled }])
    // setTableLoading(false)

  } catch (error) {
    console.error(error);
  }
};



const [syncTotalTickets, setSyncTotalTickets] = useState<any>(0)
const [lastTickeOnSync, setLastTickeOnSync] = useState<any>(null)
const [syncShortSummary, setSyncShortSummary] = useState<any>({
  done: 0,
  waiting: 0,
  failed: 0
})
const fetchAuditSummary = async () => {
  let _temp_counter = 0

  const companySlug = sessionStorage.getItem('company_slug') ||  'na'

  try {

    let response:any;

    if(companySlug === 'fluminense' || companySlug === 'flamengo'){
    // todos com mca legacy
    response = await apiEvent.get(`/sync/audit/active-events/legacy-tickets/15195`);
    }else{
      response = await apiEvent.get(`/sync/audit/active-events`);
    }


    if(response.data.data === 'error'){
      return false
    }
    setAuditDeviceList(response.data.data)
    // const sortedData = response.data.data.sort((a: any, b: any) => a.name.localeCompare(b.name));
    // setAuditDeviceList(sortedData);

    setLastTickeOnSync(response.data.lastTicket)
    for(const item of response.data.data){
      _temp_counter += Number(item.faceTotal)
    }

    const _temp_shortSync:any = {
      done: 0,
      waiting: 0,
      failed: 0
    }

    for(const syncItem of response.data.totalTicketsOnSync){
      if(syncItem.isFaceCreated === 'notStarted'){
        _temp_shortSync.waiting = syncItem.count
      }else if(syncItem.isFaceCreated === 'failed'){
        _temp_shortSync.failed = syncItem.count
      }else{
        _temp_shortSync.done = syncItem.count
      }
    }


    console.log('-  - -')
    console.log(_temp_shortSync)
    setSyncShortSummary(_temp_shortSync)

    setSyncTotalTickets(_temp_counter)

  } catch (error) {
    console.error(error);
  }

}

const [totalGameTickets, setTotalGameTickets] = useState<number>(0)
const [canceledGameTickets, setCanceledGameTickets] = useState<number>(0)

const [recountTotalTickets, setrecountTotalTickets] = useState(0)
const [lastTicketIntegrated, setLastTicketIntegrated] = useState<any>(null)
const fetchTicketsData = async () => {

  try {

    const companySlug = sessionStorage.getItem('company_slug') ||  'na'



      let response:any;

      if(companySlug === 'fluminense' || companySlug === 'flamengo'){
      // todos com mca legacy
      response = await apiEvent.get(`/tickets/vlegacy/all`);
      }else{
        response = await apiEvent.get(`/tickets/v2/all`);
      }


    setLastTicketIntegrated(response.data[0][0])
    setReportTicketList(response.data[0])
    setrecountTotalTickets(response.data[1])
  } catch (error) {
    console.error(error);
  }

}

  const downloadTickets = () => {

    const reportDownload:any = []
    for(const entrance of reportTicketList){

      const dateStr = entrance.checkInDate || 0;
      const date = new Date(dateStr);

      // Subtract 3 hours (3 hours * 60 minutes/hour * 60 seconds/minute * 1000 milliseconds/second)
      date.setTime(date.getTime() - (6 * 60 * 60 * 1000));

      const result = date.toISOString();


      reportDownload.push({
        nome: entrance.holderName,
        email: entrance.holderEmail,
        documento: entrance.holderDocument,
        temBiometria: entrance.hasFaceAssociated,
        codigo: entrance.tokens[0]?.token || entrance.tokens?.token,
        eventId: entrance.eventId,
        externalEventId: entrance.externalEventId,
        sessionId: entrance.sessionId,
        checkIn: entrance.checkInType ? result:null,
        CheckInTipo: entrance.checkInType,
        gate: entrance.gateId,
        ticket: entrance.ticket,
        status: entrance.status
      })

    }

    const worksheet = utils.json_to_sheet(reportDownload);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, 'relatorio');
    writeFile(workbook, `ingressos.xlsx`);

  }

  const downloadAccess = async (eventData: any) => {
    setLoading(true);
    try {
      const report_entrances = await apiEvent.get(`tickets/checkin/event/${eventData.eventsIdlist[0]}`);
      const reportDownload: any[] = [];
      for (const entrance of report_entrances.data.tickets) {
        const dateStr = entrance.checkInDate || 0;
        const date = new Date(dateStr);
        // Subtract 6 hours
        date.setTime(date.getTime() - 6 * 60 * 60 * 1000);
        reportDownload.push({
          nome: entrance.holderName,
          email: entrance.holderEmail,
          documento: entrance.holderDocument,
          codigo: entrance.tokens[0]?.token || entrance.tokens?.token,
          eventId: entrance.eventId,
          checkIn: date.toISOString(),
          CheckInTipo: entrance.checkInType,
          CheckInDispositivo: entrance.checkInDevice,
          ticket: entrance.tokens[0].token,
        });
      }
      const worksheet = utils.json_to_sheet(reportDownload);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, "relatorio");
      writeFile(workbook, "relatorio_de_acessos.xlsx");
    } catch (error: any) {
      setErrorModalMessage("Relatório indisponível. Por favor, tente novamente ou entre em contato com o suporte.");
      setErrorModalOpen(true);
      console.error("Erro ao baixar relatório:", error);
    } finally {
      setLoading(false);
    }
  };

  const generateOfflineTickets = async () => {
    const response = await apiJaiminho.post('/publish/topic', {
      message: 'go-genearte',
      topicName: 'generate-tickets-text'
  })

  return alert('Ingressos offline gerados com sucesso!')
  }
  


  const downloadContingency = async (externalId: string) => {
    try {
      if (!externalId) {
        console.error('ExternalId está vazio!');
        return;
      }


      const response = await apiEvent.get(`tickets/${externalId}`);


      const data = response.data.data;


      const reportDownload = data.map((entry: any) => ({
        nome: entry.name || '-',
        email: entry.email || '-',
        documento: entry.cpf || '-',
        ticket: entry.ticket || '-',
        checkIn: entry.logData || '-',
        motivo: entry.reason || '-',
        dateTimeDeletionBiometrics: entry.dateTimeDeletionBiometrics || '-',
        gate: entry.gate || '-',
        sectorId: entry.sectorId || '-',
        row: entry.row || '-',
        seat: entry.seat || '-',
      }));

      const worksheet = utils.json_to_sheet(reportDownload);
      const workbook = utils.book_new();
      utils.book_append_sheet(workbook, worksheet, 'Relatório');
      writeFile(workbook, `contingencia_${externalId}.xlsx`);

      console.log('Relatório gerado com sucesso!');
    } catch (error) {
      console.error('Erro ao gerar o relatório:', error);
    }
  };

  const [syncReceived, setSyncReceived] = useState<any>([{
    x: '20:10',
    y: 239
  },{
    x: '20:20',
    y: 716,
  },{
    x: '20:30',
    y: 301,
  },{
    x: '20:40',
    y: 918,
  }])
  const [syncUpdated, setSyncUpdated] = useState<any>([{
    x: '20:10',
    y: 229
  },{
    x: '20:20',
    y: 916,
  },{
    x: '20:30',
    y: 81,
  },{
    x: '20:40',
    y: 1318,
  }])

  const [rolucre, setRolucre] = useState<any>([])
  const fetchSyncData = async () => {

    try {
      const response = await apiEvent.get(`/sync/time/graph`);

     const rola:any = [],
     _tempReceived:any = [],
     _tempUpdated:any = []

     response.data.map((item:any) => {
        if(item.syncType === 'ticket_updated'){
          _tempUpdated.push({
            "x": dateFormatter(item.syncTime),
            "y": Number(item.totalTickets) || 0
          })
          _tempReceived.push({
            "x": dateFormatter(item.syncTime),
            "y": 0
          })
        }else{
          _tempReceived.push({
            "x": dateFormatter(item.syncTime),
            "y": 0
          })
          _tempUpdated.push({
            "x": dateFormatter(item.syncTime),
            "y": Number(item.totalTickets) || 0
          })
        }
      })

      const legendaryRola = response.data.map((item:any) => {
        if(item.syncType === 'ticket_updated'){
          return dateFormatter(item.totalTickets)
        }
      })

      setTimeout(() => {
        // setSyncReceived(_tempReceived)
        // setSyncUpdated(_tempUpdated)
      }, 1000);

    } catch (error) {
      console.error(error);
    }

  }

  const setDeviceStatus = (deviceCount:any,refferenceNumber:any) => {
    if(deviceCount === 'offline' || deviceCount === 'terminalInactive'){
      return 'offline'
    }else if(deviceCount === refferenceNumber){
      return 'idle'
    }
    return 'waiting'
  }


  let _search_submit_times = 0
  const onSubmit: SubmitHandler<FormData> = async (data) => {

    setSuccess(false);
    setLoading(true);

    setUserProfile({})
    setDisplayUserProfile(false)
    setNotFound(false)

      try {
        const response = await apiUser.post('/biometry/find/user/byDocument',
          {
            userId: data.document.replace(/\./g, '').replace(/-/g, ''),
            companyId: 'c48126a8-a719-48ca-a3a7-e19eaa388da4',
            userSearchType: 'document',
            userType: 'game'
          }
        );

        _search_submit_times = 0
        if(response.data.data && response.data.data.length === 0){

          setNotFound(true)
          setLoading(false);

          setTimeout(() => {
            setNotFound(false)
          }, 3000);
          return false
        }
        setUserProfile(response.data.data[0])
        setDisplayUserProfile(true)

        setSuccess(true);
        setLoading(false);

        setTimeout(() => {
          setSuccess(false);
        }, 2000);

      } catch (error) {
        const _temp_can_refresh = await refreshToken()
        if(_search_submit_times > 2){
          console.error(error);
          alert('Sua sessão expirou, por favor faça seu login novamente.')
          return window.location.href = '/'
        }else{
          _search_submit_times++
          if(_temp_can_refresh){
            onSubmit(data)
          }else{
            const _temp_company = sessionStorage.getItem('selected_cmp') || ''
            sessionStorage.clear()
            if(_temp_company){
              sessionStorage.setItem('selected_cmp', _temp_company)
            }
            alert('Sua sessão expirou, por favor faça seu login novamente.')
            return window.location.href = '/'
          }
        }
      }


    console.log('Form data submitted:', data);
  };

  setTimeout(() => {
    setSuccess(false);
    handleClose()
  }, 2000);
  const reloadUserData = (document:any) => {
    onSubmit({
      id: 1,
      document
    })
  }

  const updateData = () => {
    fetchData()
    fetchTicketSyncAuditSummary()
    setCompanydata({
      name: sessionStorage.getItem('company_slug') || '',
      logo: sessionStorage.getItem('company_logo') || ''
    })
  }

  useEffect(() => {
    fetchData()
    fetchTicketSyncAuditSummary()
    // fetchSyncData()
    setCompanydata({
      name: sessionStorage.getItem('company_slug') || '',
      logo: sessionStorage.getItem('company_logo') || ''
    })
  }, [])

  const [vritu, setVritu] = useState<Dayjs | null>(dayjs('2025-02-26'));

  const initialValue = dayjs('2025-02-26');

  const [highlightedDays, setHighlightedDays] = React.useState([1, 2, 15]);
  
  const requestAbortController = React.useRef<AbortController | null>(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleMonthChange = (date: Dayjs) => {
    if (requestAbortController.current) {
      // make sure that you are aborting useless requests
      // because it is possible to switch between months pretty quickly
      requestAbortController.current.abort();
    }

    setIsLoading(true);
    setHighlightedDays([]);
    fetchHighlightedDays(date);
  };


  const fetchHighlightedDays = (date: Dayjs) => {
    const controller = new AbortController();

    console.log(date.year(), date.month()+1)
    setHighlightedDays([1, 25, 17]);
    setIsLoading(false);

    // fakeFetch(date, {
    //   signal: controller.signal,
    // })
    //   .then(({ daysToHighlight }) => {
    //     setHighlightedDays(daysToHighlight);
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     // ignore the error if it's caused by `controller.abort`
    //     if (error.name !== 'AbortError') {
    //       throw error;
    //     }
    //   });

    requestAbortController.current = controller;
  };
  
  return (

    <Box>
      <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
        <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: 300,
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              textAlign: 'center',
              borderRadius: '8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
        >
          <Icon sx={{ fontSize: 40, color: 'error.main', marginBottom: 2 }}>
            warning
          </Icon>
          <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ marginBottom: 1 }}>
            Ainda há acessos para esse jogo
          </Typography>
          <Typography id="modal-modal-description" variant="body2" sx={{ color: 'text.secondary' }}>
            Entre em contato com o suporte para mais informações.
          </Typography>
        </Box>
      </Modal>
      <Grid className="graph-biometries-counter" container spacing={2}>

        <Grid size={{xs: 12, md: 9}}>
          <Typography variant="h3" gutterBottom>
            Selecione a partida
          </Typography>

{eventList && eventList.length > 0 && (
   <Box className="event-select">
   <FormControl  fullWidth>
           <InputLabel id="demo-simple-select-label">Escolher</InputLabel>
           <Select
             labelId="demo-simple-select-label"
             id="demo-simple-select"
             // value={age}
             label="Escolher"
             defaultValue={eventList[0].id}
             onChange={(e) => {changeEventSummary(e.target.value)}}
           >
             {eventList && eventList.map((item:any, index:any) => (
               <MenuItem  key={index} value={item.id}>{item.name}</MenuItem>
             ))}

           </Select>
         </FormControl>
   </Box>
)}




          <Box className="event-main-display">

          {bannerData.status === 'active' && (
              <Box
                className="action-row"
                onClick={() => downloadContingency(bannerData.externalId)}
              >
                <span>contingência</span>
                <i><InsertChartOutlinedIcon /></i>
              </Box>

            )}


            <Typography variant="h1" noWrap component="h1">
              {sessionStorage.getItem('company_slug') === 'botafogo' && 'Nilton Santos' }
              {sessionStorage.getItem('company_slug') === 'flamengo' && 'Maracanã' }
              {sessionStorage.getItem('company_slug') === 'gremio' && 'Arena Poa ' }
              {sessionStorage.getItem('company_slug') === 'fluminense' && 'Maracanã' }
              {sessionStorage.getItem('company_slug') === 'dunas' && 'Arena Dunas' }
              {sessionStorage.getItem('company_slug') === 'palmeiras' && 'Allianz Parque' }
              {sessionStorage.getItem('company_slug') === 'fonte-nova' && 'Arena Fonte Nova' }
              {sessionStorage.getItem('company_slug') === 'santos' && 'Vila Belmiro' }
            • {dateFormatter(bannerData.eventDate)}
            </Typography>

            <Box className="event-card-game">
              <Box className="game-club" sx={{ display: { xs: 'none', md: 'block' }}}>
                <img src={companydata.logo} alt={bannerData.home} />
              </Box>

              <Box className="game-event-details">
                <Typography variant="h3" noWrap component="h3">
                  {bannerData.home}
                </Typography>
                <Typography variant="caption" noWrap component="span">
                 vs
                </Typography>
                <Typography variant="h3" noWrap component="h3">
                {bannerData.visitor}
                </Typography>
              </Box>

              <Box className="game-club" sx={{ display: { xs: 'none', md: 'block' }}}>
                <img src={bannerData.visitorLogo} alt={bannerData.visitor} title={bannerData.visitor} />
              </Box>
            </Box>

      <Box className="button-group">
      <Button type="submit" variant="contained" color="info"
       onClick={() => generateOfflineTickets()}>
            Gerar Tickets offline
      </Button>
      <Button variant="contained" color="primary"
      onClick={() => downloadTickets()}
      >
            Baixar tickets
      </Button>
      <Button  disabled={bannerData.status === 'active' ? true:false} variant="contained" color="primary"
      onClick={() => activateGame(bannerData)}>
        iniciar Partida
      </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => downloadAccess(bannerData)}
                disabled={loading}
                className={`report-access-btn ${loading ? "loading" : ""}`}
              >
                Relatório de acessos
                {loading && (
                  <CircularProgress
                    size={24}
                    className="spinner-overlay"
                  />
                )}
              </Button>
            </Box>
          </Box>

          {ticketsSyncAuditSummary && (
          <Box className="event-sync-symmary">
      <Typography variant="h2">
                Descritivo de ingressos e sincronização por setor
      </Typography>

      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Setor</TableCell>
            <TableCell>Ingressos Recebidos</TableCell>
            <TableCell>Ingressos Sincronizados</TableCell>
            <TableCell>Diferença</TableCell>
            <TableCell>% Diferença</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
          ticketsSyncAuditSummary.map((item:any, index:any) => (
            <TableRow
              key={index}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
            <TableCell>{item.gateAlias}</TableCell>
            <TableCell>{item.activeTickets}</TableCell>
            <TableCell>{item.minDeviceImageCount || 0}</TableCell>
            <TableCell>{(item.activeTickets - item.minDeviceImageCount)}</TableCell>
            <TableCell>
            {item.minDeviceImageCount > item.activeTickets 
              ? `${((item.minDeviceImageCount - item.activeTickets) / item.activeTickets * 100).toFixed(2)}%` 
              : `${((item.activeTickets - item.minDeviceImageCount) / item.activeTickets * 100).toFixed(2)}%`}
            </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </Box>

)}
        </Grid>

        <Grid size={3} sx={{ display: { xs: 'none', md: 'block' }}}>
       {/*    <Typography variant="h3" gutterBottom>
            Data do evento
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
        />
         open={true}
         closeOnSelect={false} */}

  {/*   </LocalizationProvider>

         <DesktopDatePicker
          onChange={handleChange}
          /> */}
        </Grid>
      </Grid>



      <Typography variant="subtitle1" sx={{mb: 2}} component="h2">
        Pesquisar sincronização de torcedores
        </Typography>

      <Grid className="user-search"  sx={{mb: 6}} container spacing={2}>
      <Grid  size={{xs: 12, md: 5}}>
<form className='user-search-form' onSubmit={handleSubmit(onSubmit)}>
      <FormControl fullWidth={true} variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Pesquisar documento</InputLabel>
          <OutlinedInput
          {...register("document", { required: "Nome é obrigatório!" })}
          error={!!errors.document}
            id="outlined-adornment-password"
            endAdornment={
              <InputAdornment position="end">
                <Button
                type='submit'>
<IconButton
                  // onClick={handleClickShowPassword}
                  // onMouseDown={handleMouseDownPassword}
                  // onMouseUp={handleMouseUpPassword}
                  edge="end"
                >
                  <SearchIcon />
                </IconButton>
                </Button>
              </InputAdornment>
            }
            label="Pesquisar documento"
          />

        </FormControl>
        {notFound && (
          <Alert severity="info" color="warning">
          Usuário não encontrado
        </Alert>
        )}
        </form>

  </Grid>
  <Grid size={{xs: 12, md: 12}}>
  {loading && (
    <UserCardLoader/>
  )}
  {displayUserProfile && (
    <>
    <UserEventCart userData={userProfile} handleCloseBox={closeUserSearchBox} handleRefresh={reloadUserData} />
    </>
  )}
  </Grid>
</Grid>  

    <Box className="event-sync-symmary">
      <Typography variant="h2">
        Resumo
      </Typography>

      <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Ingressos vendidos</TableCell>
            <TableCell>Ingressos cancelados</TableCell>
            <TableCell>Ingressos sincronizados</TableCell>
            <TableCell>CPF em duplicidade</TableCell>
            <TableCell>Último ingresso recebido</TableCell>
            <TableCell>Última sincronização</TableCell>
            <TableCell>Fila de sincronização</TableCell>
            <TableCell>Erro de sincronização</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
            <TableRow
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
            <TableCell>{totalGameTickets || recountTotalTickets}</TableCell>
            <TableCell>{canceledGameTickets}</TableCell>
            <TableCell>{syncShortSummary.done || 0}</TableCell>
            <TableCell>{duplicatedTickets?.length}</TableCell>
            <TableCell>{dateFormatter(lastTicketIntegrated?.createdAt, false, true)}</TableCell>
            <TableCell>{dateFormatter(lastTickeOnSync?.updatedAt, false, true)}</TableCell>
            <TableCell>{syncShortSummary.waiting || 0}</TableCell>
            <TableCell>{syncShortSummary.failed || 0}</TableCell>
            </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </Box>


    <Box className="sync-summary-header" sx={{mb: 6}}>
    <Typography variant="h2" gutterBottom>
            Dispositivos
          </Typography>
          <ul className="sync-symmary-status">
            <li className='status-idle'>sincronizado</li>
            <li className='status-waiting'>sinc em andamento</li>
            <li className='status-offline'>off-line</li>
          </ul>

          <Box sx={{ display: { xs: 'none', md: 'block' }}}>
          <Button onClick={() => updateData()} type="submit" variant="contained" color="primary">Atualizar</Button>
          </Box>
    </Box>


        {auditDeviceList.length > 0 &&
        auditDeviceList.map((item:any, index:any) => (
          <Accordion key={index} className='accordion-sync'>
          <AccordionSummary
            expandIcon={null}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Box className="accordion-sync-symmary">
            {item.gateName}
              <ExpandMoreIcon />
            </Box>
            <SyncSummaryHeader syncData={item} />
          </AccordionSummary>


          <AccordionDetails>
           <ul className="accordion-sync-list">
            {item.devices.length > 0 &&
            item.devices.map((devices:any, index:any) => (
              <li key={index} className={setDeviceStatus(devices.count, item.faceTotal)}>
              <Typography variant="h3" gutterBottom>
                <span>{devices.ip}</span>
                {!isNaN((Number(devices.count))) ? devices.count: 'offline'}
              </Typography>
            </li>
            ))}
            {/* {[{
              device: 'D-01PCD',
              count:'12.100',
              status: 'idle'
            },{
              device: 'D-02T',
              count:'11.322',
              status: 'waiting'
            },{
              device: 'D-03T',
              count:'0',
              status: 'offline'
            },{
              device: 'D-04T',
              count:'0',
              status: 'offline'
            }].map((item, index) => (
               <li key={index} className={item.status}>
               <Typography variant="h3" gutterBottom>
                 <span>{item.device}</span>
                 {item.count}
               </Typography>
             </li>
             ))} */}
            </ul>
          </AccordionDetails>
        </Accordion>


        ))}

      <Modal
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
      >
        <Box className="modal-box">
          <IconButton className='icon-button' onClick={() => setErrorModalOpen(false)}>
            <CloseIcon />
          </IconButton>
          <Icon  className="icon-warning">
            warning
          </Icon>
          <Typography className="modal-description">
            {errorModalMessage}
          </Typography>
        </Box>
      </Modal>
    </Box>
  )
};

export default GameSync;

function ServerDay(props: PickersDayProps<Dayjs> & { highlightedDays?: number[] }) {
  const { highlightedDays = [], day, outsideCurrentMonth, ...other } = props;

  const isSelected =
    !props.outsideCurrentMonth && highlightedDays.indexOf(props.day.date()) >= 0;

  return (
    <Badge
      key={props.day.toString()}
      overlap="circular"
      badgeContent={isSelected ? '🌚' : undefined}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
    </Badge>
  );
}
